import LandingPage from './landing/LandingPage';

/**
 * Web entry: redesigned landing + route-weather dashboard.
 * Native continues to use App.js.
 */
export default function App() {
  return <LandingPage />;
}
